import { render } from "./SelecaoChecklist.vue?vue&type=template&id=69ad7fdd&scoped=true"
import script from "./SelecaoChecklist.vue?vue&type=script&lang=js"
export * from "./SelecaoChecklist.vue?vue&type=script&lang=js"

import "./SelecaoChecklist.vue?vue&type=style&index=0&id=69ad7fdd&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ad7fdd"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
